<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="130px" :model="formLabelAlign">
      <el-form-item label="微信模板库编号">
        <el-input v-model="formLabelAlign.template_id_short" />
      </el-form-item>
      <el-form-item label="模板名称">
        <el-input v-model="formLabelAlign.template_name" />
      </el-form-item>
      <el-form-item label="使用方式">
        <div class="tipsr">{{ tips }}</div>
      </el-form-item>
      <el-form-item label="模板变量">
        <div class="sdwrwr">
          <div v-for="item,index in arr" :key="index" class="dawrewr">
            <span style="margin:0px 10px">标题</span><el-input v-model="item.title" style="width:150px" placeholder="输入标题" :disabled="item.disarw" />
            <span style="margin-left:10px">key</span><el-input v-model="item.key" style="width:150px;margin-left:10px" placeholder="输入key" :disabled="item.disarw" />

            <el-button v-if="index==0" type="primary" style="margin-left:10px" icon="el-icon-plus" @click="addtewe(item)" />
            <el-button v-if="index!=0 && index!=arr.length-1" type="danger" style="margin-left:10px" icon="el-icon-minus" @click="deleter(index)" />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="相似的模板编号">
        <el-tag v-if="formLabelAlign.similar_id!=''" style="margin-right:10px">{{ name }}</el-tag>
        <el-tag type="warning" @click="choosesimer">选择相似的模板编号</el-tag>
      </el-form-item>
      <el-form-item label="优先级">
        <el-input v-model="formLabelAlign.priority_level" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="determine">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择相似的号"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <similar ref="simnre" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { templatemessageliball, updatelibr } from '@/api/sourceMaterial.js'
import similar from './similar.vue'
export default {
  components: {
    similar
  },
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        template_id_short: '',
        template_name: '',
        similar_id: '',
        priority_level: ''
      },
      tips: '如何获取标题和key?  例如:订单号：{{keyword1.DATA}}，标题填写"订单号" key填写"keyword1"',
      arr: [{
        title: '小标题',
        key: 'first',
        disarw: true
      },
      {
        title: '备注信息',
        key: 'remark',
        disarw: true
      }],
      type: null,
      name: '',
      dialogVisible: false,
      ids: null,
      arrsw: [],
      editarr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendrs(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('新增')
      } else {
        this.ids = item.id
        this.formLabelAlign.template_id_short = item.template_id_short
        this.formLabelAlign.template_name = item.template_name
        this.formLabelAlign.similar_id = item.similar_id
        this.formLabelAlign.priority_level = item.priority_level
        this.name = item.similar_template_name

        // this.arr = item.variable
        item.variable.forEach((items, index) => {
          // console.log('index', index, item.variable.length - 1)
          // 0 3
          // 1 3
          // 2 3
          // 3 3
          // eslint-disable-next-line eqeqeq
          if (index != 0 && index != item.variable.length - 1) {
            this.editarr.push({
              title: items.title,
              key: items.key,
              disarw: false
            })
          } else {
            this.editarr.push({
              title: items.title,
              key: items.key,
              disarw: true
            })
          }
        })
        this.arr = this.editarr
        console.log('编辑', this.editarr)
      }
    },
    choosesimer() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.simnre.sendrs()
      }, 100)
    },
    callback(item) {
      console.log('item', item)
      this.dialogVisible = false
      this.formLabelAlign.similar_id = item.template_id_short
      this.name = item.template_name
    },
    addtewe(item) {
      // this.arr.push({
      //   title: item.title,
      //   key: item.key,
      //   disarw: false
      // })
      this.arr.splice(this.arr.length - 1, 0, { title: '', key: '', disarw: false })
      console.log('this.arr', this.arr)
      // var fruits = ['Banana', 'Orange', 'Apple', 'Mango']

      // fruits.splice(this.arr.length - 1, 0, 'Lemon', 'Kiwi')
      // console.log('fruits', fruits)
    },
    deleter(index) {
      this.arr.splice(index, 1)
    },
    async determine() {
      if (this.formLabelAlign.template_id_short === '') {
        this.$message.error('请填写微信模板库编号')
        return
      }
      if (this.formLabelAlign.title === '') {
        this.$message.error('请填写模板名称')
        return
      }
      const bools = this.arr.every((item, index, array) => {
        return item.title !== ''
      })
      if (bools === false) {
        this.$message.error('请填写标题')
        return
      }
      const keybools = this.arr.every((item, index, array) => {
        return item.key !== ''
      })
      if (keybools === false) {
        this.$message.error('请填写key')
        return
      }
      this.arrsw = []
      this.arrsw = this.arr.map(item => {
        return { title: item.title, key: item.key }
      })
      console.log('this.arrsw', this.arrsw)

      // if (this.formLabelAlign.priority_level === '') {
      //   this.$message.error('请填写优先级')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        //  新增
        const data = await templatemessageliball({
          template_id_short: this.formLabelAlign.template_id_short,
          template_name: this.formLabelAlign.template_name,
          variable: this.arrsw,
          similar_id: this.formLabelAlign.similar_id,
          priority_level: this.formLabelAlign.priority_level
        })
        this.$message({
          type: 'success',
          message: '新增成功'
        })
        this.$emit('updata')
        console.log('data', data)
      } else {
        const data = await updatelibr({
          template_id_short: this.formLabelAlign.template_id_short,
          template_name: this.formLabelAlign.template_name,
          variable: this.arrsw,
          similar_id: this.formLabelAlign.similar_id,
          priority_level: this.formLabelAlign.priority_level,
          id: this.ids
        })
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.$emit('updata')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sdwrwr{
  max-height: 230px;
  overflow: hidden;
  overflow-y: scroll;
}
.dawrewr{
  margin-bottom:10px;
}
.tipsr{
  color: red;
}
</style>
